module.exports = __webpack_public_path__ + "img/Mask_Group_282.4f1a0a82.png";